module.exports = __webpack_public_path__ + "img/beach.8fe99d8d.jpg";